import { Button, Skeleton } from "antd";
import { FolderAddOutlined } from "@ant-design/icons";

export const AddInvoiceToClaimLoading = () => {
  return (
    <Button size="middle" icon={<FolderAddOutlined />} disabled>
      <Skeleton.Input active size="small" style={{ width: 80, height: 14 }} />
    </Button>
  );
};
